function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Mail");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Foundation-/-icons-/-envelope",
  transform: "translate(-2.000000, -4.000000)",
  fill: "#06273A"
}, React.createElement("path", {
  d: "M19,3.99999999 L4.99999999,3.99999999 C3.34314574,3.99999999 1.99999999,5.34314574 1.99999999,6.99999999 L1.99999999,17 C1.99999999,18.6568543 3.34314574,20 4.99999999,20 L19,20 C20.6568543,20 22,18.6568543 22,17 L22,6.99999999 C22,5.34314574 20.6568543,3.99999999 19,3.99999999 Z M18.59,5.99999999 L12.71,11.88 C12.5222334,12.0693127 12.2666375,12.1757983 12,12.1757983 C11.7333625,12.1757983 11.4777666,12.0693127 11.29,11.88 L5.40999999,5.99999999 L18.59,5.99999999 Z M20,17 C20,17.5522848 19.5522848,18 19,18 L4.99999999,18 C4.44771524,18 3.99999999,17.5522848 3.99999999,17 L3.99999999,7.41 L9.88,13.29 C11.0512702,14.4598135 12.9487298,14.4598135 14.12,13.29 L20,7.41 L20,17 Z"
})));

var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail.52db455d.svg";
export { ForwardRef as ReactComponent };